
import React, { useState, useEffect } from "react";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FromDateToDate from '../CommonComponents/FromDateToDate';
import {
    withStyles,
    makeStyles,
    createStyles,
    useTheme,
} from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import {
    FormHelperText,
    Input,
    InputLabel,
    InputBase,
    Button,
} from "@material-ui/core";

import { addDays } from 'date-fns';

import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRange } from 'react-date-range';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CancelIcon from '@mui/icons-material/Cancel';
import { getCookie } from "../../services/Cookies";
import { FilterObj } from '../CommonComponents/globalfilterObj';

const useStyles = makeStyles((theme) => ({
    justifyContentBetween: {
        justifyContent: "space-between!important",
    },
    alignItemsStretch: {
        alignItems: "stretch",
    },
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    paper: {
        padding: theme.spacing(2),
        // textAlign: "center",
        color: theme.palette.text.secondary,
    },
    gridSpacing: {
        margin: "0 !important",
        width: "100% !important",
    },
    btnFilters: {
        color: "#ff4717",
        border: "1px solid rgb(255 71 23)",
        textTransform: "capitalize",
    },
    alignment: {
        alignItems: "center",
    },
    button: {
        display: 'block',
        marginTop: theme.spacing(2),
    },
    btnStyle2: {
        borderRadius: "8px",
        border: "2px solid #ff4717",
        boxShadow: "2px 2px 4px 2px #dadada",
        color: "#ffffff",
        background: "#ff4717 !important",
        textTransform: "capitalize",
        padding: "4px 22px",
        marginRight: "8px"
    },
    dateleft: {
        maxWidth: "45%",
        display: "inline-block",
    },
    dateright: {
        maxWidth: "45%",
        marginLeft: "5%",
        display: "inline-block",
    },
    formControl: {
        // margin: theme.spacing(1),
        minWidth: "200px",
        "& select": {
            padding: "6px"
        }
    },
    fromdate: {
        display: 'inline',
        fontSize: '14px',
        marginLeft: '365px',
        fontFamily: 'Bai Jamjuree, sans-serif !important',
        fontWeight: 'bold'
    },
    todate: {
        display: 'inline',
        fontSize: '14px',
        marginLeft: '265px',
        fontFamily: 'Bai Jamjuree, sans-serif !important',
        fontWeight: 'bold'
    },
    label: {
        "& .rdrDateDisplayItem input": {
            color:"#000000",
            fontWeight: 'bold'
        },
        "& .rdrMonthName": {
            color: "#000000",
        },
        "& .rdrWeekDay": {
            color: "#000000",
            fontWeight: 500
        },
        "& .rdrDayNumber span": {
            fontWeight: 500
        },
        "& .rdrDateDisplayItemActive": {
            borderColor:"#ff4717",
            backgroundColor: "#ff4717",
            borderWidth: "2px"
        }
    }
}));
const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(2),
        },
    },

    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.common.white,
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "auto",
        padding: "10px 12px",
        height: "0.1876em",
        // marginLeft: '2.2em',
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
        "&.Mui-disabled": {
            backgroundColor: "#eee"
        }
    },
}))(InputBase);

const BootstrapDate = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(2),
        },
    },

    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.common.white,
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "100%",
        padding: "10px 12px",
        height: "0.1876em",
        // marginLeft: '2.2em',
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
        "&.Mui-disabled": {
            backgroundColor: "#eee"
        }

    },
}))(InputBase);

export default function FqtReportDateComponent(props) {
    const classes = useStyles();
    const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
    const { globalfilter, updateParent,reset, type } = props;

    const [formObj, setFormObj] = useState(FilterObj);

    const [open, setOpen] = React.useState(false);
    /* const [reportDate, setReportDate] = useState([
        {
            startDate: "",
            endDate: "",
            key: 'selection'
        }
    ]); */
    const dateopen = () => {
        //
        setOpen(true);
    }
    const clearDate=()=>{
        setFormObj({ ...formObj, Fqtreportstartdate:"", Fqtreportenddate:  ""});
         props.isFilterDisabledClear(true);
        /* setReportDate([
             {
                 startDate: null,
                 endDate: null,
                 key: 'selection'
               }
         ]); */
     }
 
    const handleClose = () => {
        setOpen(false);
    }
    const handleChangeDate = (DateValue) => {
        //
        props.onChange(DateValue);
        //setReportDate(DateValue);
        setFormObj({ ...formObj, Fqtreportstartdate:DateValue[0].startDate, Fqtreportenddate: DateValue[0].endDate })
    }
    const dateFormat = (val) => {
        // //
        if (val !== "" && val !== undefined && val !== null && !isNaN(val)) {
            let DateObject = val;
            let date = DateObject.getDate();
            let month = DateObject.getMonth() + 1;
            let year = DateObject.getFullYear();
            let DateValue = date + '/' + month + '/' + year;
            return DateValue;
        }
        return "";
    }
    const defaultdateformet = (pageloadvalue) => {
        // //
        if (pageloadvalue !== "" && pageloadvalue !== undefined && pageloadvalue !== null) {
            let DateObject = new Date(pageloadvalue);
            let date = DateObject.getDate();
            let month = DateObject.getMonth() + 1;
            let year = DateObject.getFullYear();
            let DateValue = date + '/' + month + '/' + year;
            return DateValue;
        }
        return "";
    }
    const defaultValue = (val) => {
        //
        if (val !== "" && val !== undefined && val !== "null") {
            let Obj = JSON.parse(val);
            if(props.Fqtreportstartdate)
            Obj.Fqtreportstartdate=props.Fqtreportstartdate;
            if(props.Fqtreportenddate)
            Obj.Fqtreportenddate=props.Fqtreportenddate;
            setFormObj(Obj);
            //console.log('getcookievalue', formObj)
        }
        else{
            let Obj = {};
            if(props.Fqtreportstartdate)
            Obj.Fqtreportstartdate=props.Fqtreportstartdate;
            if(props.Fqtreportenddate)
            Obj.Fqtreportenddate=props.Fqtreportenddate;
            setFormObj(Obj);
        }
    }
    React.useEffect(() => {
        //
        if (reset>0)
        defaultValue(GlobalFilterSettingValue);
        
    }, [reset]);
    React.useEffect(() => {
        //
        defaultValue(GlobalFilterSettingValue);
    }, []);
    return (
        <div>
            <Dialog
                //fullWidth={fullWidth}
                //maxWidth={maxWidth}
                maxWidth="xl"
                //fullScreen={true}
                open={open}
                onClose={handleClose}
            >
                <DialogActions>
                    <Button onClick={handleClose}><CancelIcon /></Button>
                </DialogActions>
                <DialogTitle >
                    <Box component="div" className={classes.fromdate}>From Date</Box>
                    <Box component="div" className={classes.todate}>To Date</Box>
                </DialogTitle>
                <DialogContent>
                    {/* <FromDateToDate onChange={datevalue}/> */}
                    <DateRangePicker
                        //onChange={(item)=>{//setState([item.selection])}}
                        className={classes.label}
                        onChange={(item) => handleChangeDate([item.selection])}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={true}
                        months={2}
                        //ranges={props.value}
                        ranges={[
                            {
                                startDate: formObj.Fqtreportstartdate,
                                endDate: formObj.Fqtreportenddate,
                                key: 'selection',
                                color: "#ff4717"
                            }
                        ]}
                        direction="horizontal"
                    />
                </DialogContent>

            </Dialog>
            <Grid container spacing={2}>

                <Grid item  >

                    <BootstrapInput

                        readonly
                        //value={dateFormat(props.value[0].startDate)}
                        value={defaultdateformet(formObj.Fqtreportstartdate) }
                    //value={reportDate[0].startDate}
                    />
                </Grid>
                <Grid item className="ptl10">
                    <BootstrapInput
                        name="vessel"
                        //value={dateFormat(props.value[0].endDate)}
                        value={ defaultdateformet(formObj.Fqtreportenddate) }
                        //value={reportDate[0].endDate}
                        format="DD/MM/YYYY"
                        readonly

                    />
                    <Button onClick={dateopen} className="datecalicon"><CalendarMonthIcon /></Button>
                    <Button onClick={clearDate} className="datecalicon"><CancelIcon /></Button>
                </Grid>


            </Grid>





        </div>
    )

}
